import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { surrealRecordSchema } from "./surreal-record";
import { getTenantSchemaAdditionalFields, tenantSchema } from "./tenant";

export const leaseSchema = surrealRecordSchema.extend({
  tenants: z.lazy(() => z.array(tenantSchema)),
  fromDate: z.coerce.date(),
  toDate: z.coerce.date().optional(),
  customName: z.string().optional(),
  additionalData: additionalDataSchema,
});

export type Lease = z.infer<typeof leaseSchema>;

export function getLeaseSchemaAdditionalFields(additionalFields: {
  lease: typeof additionalDataSchema;
  person: typeof additionalDataSchema;
  organization: typeof additionalDataSchema;
}): typeof leaseSchema {
  return leaseSchema.extend({
    tenants: z.lazy(() =>
      z.array(getTenantSchemaAdditionalFields(additionalFields)),
    ),
    additionalData: additionalFields.lease,
  });
}
